const PrivacyPolicyContent = () => (
  <div className="privacy-drawer__content">
    <p className="privacy-drawer__lead">
      En Tecnotics, nos comprometemos a proteger la privacidad y seguridad de los datos personales
      de nuestros usuarios y clientes. Esta política explica cómo recopilamos, usamos y protegemos
      tu información.
    </p>

    <section className="privacy-drawer__section">
      <h2>1. Información que recopilamos</h2>
      <ul>
        <li>Datos de contacto: nombre, correo electrónico, teléfono, empresa.</li>
        <li>
          Información proporcionada a través de formularios de contacto, cotización o suscripción.
        </li>
        <li>Datos de navegación y cookies para mejorar la experiencia en nuestro sitio web.</li>
      </ul>
    </section>

    <section className="privacy-drawer__section">
      <h2>2. Uso de la información</h2>
      <ul>
        <li>Responder a tus consultas, solicitudes de información o cotizaciones.</li>
        <li>Brindar y mejorar nuestros servicios tecnológicos.</li>
        <li>Enviar comunicaciones comerciales, solo si has dado tu consentimiento.</li>
        <li>Cumplir con obligaciones legales y de seguridad.</li>
      </ul>
    </section>

    <section className="privacy-drawer__section">
      <h2>3. Protección de datos</h2>
      <ul>
        <li>
          Implementamos medidas técnicas y organizativas para proteger tus datos contra accesos no
          autorizados, pérdida o alteración.
        </li>
        <li>Solo el personal autorizado puede acceder a la información personal.</li>
      </ul>
    </section>

    <section className="privacy-drawer__section">
      <h2>4. Derechos del usuario</h2>
      <ul>
        <li>
          Puedes acceder, rectificar, cancelar u oponerte al uso de tus datos personales en
          cualquier momento.
        </li>
        <li>
          Para ejercer tus derechos, contáctanos a{" "}
          <a href="mailto:alejandro@tecnotics.com">alejandro@tecnotics.com</a>.
        </li>
      </ul>
    </section>

    <section className="privacy-drawer__section">
      <h2>5. Uso de cookies</h2>
      <ul>
        <li>
          Utilizamos cookies propias y de terceros para analizar la navegación y mejorar nuestros
          servicios.
        </li>
        <li>
          Puedes configurar tu navegador para rechazar cookies, aunque esto podría afectar la
          funcionalidad del sitio.
        </li>
      </ul>
    </section>

    <section className="privacy-drawer__section">
      <h2>6. Cambios en la política</h2>
      <ul>
        <li>
          Nos reservamos el derecho de modificar esta política para adaptarla a novedades
          legislativas o mejoras internas.
        </li>
        <li>Te recomendamos revisarla periódicamente.</li>
      </ul>
    </section>

    <section className="privacy-drawer__section">
      <h2>7. Contacto</h2>
      <p>
        Si tienes dudas sobre nuestra política de privacidad o el tratamiento de tus datos,
        escríbenos a <a href="mailto:alejandro@tecnotics.com">alejandro@tecnotics.com</a>.
      </p>
    </section>
  </div>
);

export default PrivacyPolicyContent;
